// Color de cada sub-pestaña de "Egreso de Cheques": cheque (verde azulado), traspaso (azul) y recibo (violeta).
export const SUB_COLORES = ["#0e6b6b", "#1565c0", "#7b1fa2"];
